/* Custom element survives Impact's innerHTML/replaceChildren drawer refreshes. */
(() => {
  if (customElements.get('sb-cart-washer')) return;
  let pending = false;
  class CartWasher extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.addEventListener('click', async event => {
        const option = event.target.closest('[data-washer-option], [data-washer-silver]');
        if (option && !pending) {
          const off = option.getAttribute('aria-pressed') === 'true' && option.hasAttribute('data-washer-option');
          this.querySelectorAll('[aria-pressed]').forEach(b => b.setAttribute('aria-pressed', String(!off && b === option)));
          this.variant = off ? '' : (option.dataset.id || '');
          const image = this.querySelector('[data-washer-image]');
          if (image) { image.hidden = !this.variant; if (this.variant) { image.src = option.dataset.image; image.alt = option.dataset.name; } }
          const priceEl = this.querySelector('[data-washer-price]');
          priceEl.textContent = '';
          if (!this.variant) { priceEl.textContent = 'Silber ist Standard – gratis'; }
          else {
            if (option.dataset.compareLabel) { const s = document.createElement('s'); s.textContent = option.dataset.compareLabel; priceEl.append(s, ' '); }
            const b = document.createElement('b'); b.textContent = option.dataset.priceLabel; priceEl.append(b, ' je Halter');
          }
          this.querySelector('[data-washer-add]').hidden = !this.variant;
        }
        const button = event.target.closest('[data-washer-add]');
        if (!button || !this.variant || pending) return;
        pending = true; button.disabled = true; button.setAttribute('aria-busy', 'true');
        const status = this.querySelector('[data-washer-status]'); status.textContent = '';
        const root = window.Shopify?.routes?.root || '/';
        let added = false;
        try {
          // Re-read immediately before mutation; never trust stale drawer quantities.
          const currentResponse = await fetch(root + 'cart.js');
          if (!currentResponse.ok) throw new Error('Warenkorb konnte nicht geladen werden.');
          const current = await currentResponse.json();
          const needed = CartWasher.needed(current.items);
          if (!needed) { document.dispatchEvent(new CustomEvent('cart:refresh')); return; }
          const response = await fetch(root + 'cart/add.js', {
            method:'POST', headers:{'Content-Type':'application/json'},
            body:JSON.stringify({items:[{id:Number(this.variant),quantity:needed}]})
          });
          const result = await response.json();
          if (!response.ok) throw new Error(result.description || 'Hinzufügen fehlgeschlagen. Bitte erneut versuchen.');
          added = true;
          // Read back real final prices. No synthetic 6-Euro discount in UI or payload.
          const verified = await fetch(root + 'cart.js');
          if (!verified.ok) throw new Error('Hinzugefügt; bitte Warenkorb neu laden, um den Preis zu prüfen.');
          const cart = await verified.json();
          const lines = cart.items.filter(item => String(item.variant_id) === this.variant);
          const previousQuantity = current.items.filter(item => String(item.variant_id) === this.variant).reduce((sum,item) => sum + item.quantity, 0);
          if (!lines.length || lines.reduce((sum,item) => sum + item.quantity, 0) < previousQuantity + needed) throw new Error('Warenkorb bitte neu laden und Auswahl prüfen.');
          status.textContent = 'Hinzugefügt.';
          if (this.dataset.cartPage === 'true') { location.reload(); return; }
          document.dispatchEvent(new CustomEvent('cart:refresh'));
        } catch (error) {
          status.textContent = error.message;
          if (added) { button.hidden = true; document.dispatchEvent(new CustomEvent('cart:refresh')); }
        } finally {
          pending = false; button.disabled = false; button.removeAttribute('aria-busy');
        }
      });
    }
    static needed(items) {
      let units = 0, details = 0;
      items.forEach(item => {
        const h = item.handle || '', q = Number(item.quantity) || 0;
        if (h === 'suitbase®-pro-v4-2er-bundle') units += q * 2;
        else if (h === 'suitbase®-pro-v4-3er-bundle') units += q * 3;
        else if (h.includes('pro-v4-')) units += q;
        if (h.startsWith('detail-')) details += q;
      });
      return Math.max(0, units - details);
    }
  }
  customElements.define('sb-cart-washer', CartWasher);
})();
